import { Route } from '@angular/router';
import { AuthGuardService } from './core/services/auth/auth-guard.service';

export const appRoutes: Route[] = [
	{
		path: 'login',
		loadChildren: () =>
			import('./features/auth/pages/login/login.module').then((route) => route.LoginModule),
	},
	{
		path: '',
		loadChildren: () =>
			import('./core/pages/main-page/main-page.module').then((route) => route.MainPageModule),
		canActivate: [AuthGuardService],
	},
	{ path: '**', redirectTo: '' },
];
